import { render } from "./error-page.vue?vue&type=template&id=38f8a578&scoped=true&ts=true"
import script from "./error-page.ts?vue&type=script&lang=ts&external"
export * from "./error-page.ts?vue&type=script&lang=ts&external"

import "./error-page.less?vue&type=style&index=0&id=38f8a578&lang=less&scoped=true&external"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f8a578"]])

export default __exports__